import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as ActivityService from 'services/agents/lead/activity';

export const useLeadActivityService = () => {
  const { token, email, id } = useSelector((store) => store.user_data);
  const actor = email || (id != null ? String(id) : null);

  const createActivity = async (data, options = {}) => {
    const { error, payload } = await ActivityService.create({
      ...options,
      data: { actor, ...data },
      token
    });

    if (error) {
      toast.error('Unable to log activity at this time.');
      return { activity: null };
    }

    const activity = payload?.data || payload?.activity || payload || null;
    return { activity };
  };

  const fetchActivities = async (options = {}) => {
    const { error, payload } = await ActivityService.read({ ...options, token });

    if (error) {
      toast.error('Unable to fetch activities at this time.');
      return { activities: [], size: 0, next_page: null };
    }

    const activities = payload?.data || payload?.activities || [];
    const size = payload?.meta?.size ?? activities.length;
    const next_page = payload?.meta?.next_page ?? null;
    return { activities, size, next_page };
  };

  const updateActivity = async (activity_id, data, options = {}) => {
    const { error, payload } = await ActivityService.updateById(activity_id, {
      ...options,
      data: { actor, ...data },
      token
    });

    if (error) {
      toast.error('Unable to update activity at this time.');
      return { activity: null };
    }

    const activity = payload?.data || payload?.activity || payload || null;
    return { activity };
  };

  const deleteActivity = async (activity_id, options = {}) => {
    const { error } = await ActivityService.deleteOne(activity_id, { ...options, token });

    if (error) {
      toast.error('Unable to delete activity at this time.');
      return false;
    }

    return true;
  };

  const searchActivities = async (keys, keyword, options = {}) => {
    const { error, payload } = await ActivityService.search(keys, keyword, { ...options, token });

    if (error) {
      toast.error('Unable to search activities at this time.');
      return { activities: [], size: 0 };
    }

    const activities = payload?.data || payload?.activities || [];
    const size = payload?.meta?.size ?? activities.length;
    return { activities, size };
  };

  return {
    createActivity,
    fetchActivities,
    updateActivity,
    deleteActivity,
    searchActivities
  };
};
